import { Currency, CurrencyAmount } from '@kodiak-finance/sdk-core'
import { useCallback } from 'react'

export default function usePercentageHandlers(
  amount: CurrencyAmount<Currency> | undefined,
  setInputValue: (value: string) => void,
  onMax?: () => void
) {
  // Handler for Max button
  const handleMax = useCallback(() => {
    if (onMax) {
      onMax()
    } else if (amount) {
      setInputValue(amount.toExact())
    }
  }, [amount, setInputValue, onMax])

  const createPercentHandler = useCallback(
    (percent: number) => {
      return () => {
        if (amount) {
          try {
            const fraction = percent * 100
            const percentAmount = amount.multiply(fraction).divide(100)
            setInputValue(percentAmount.toExact())
          } catch (error) {
            console.error('Error calculating percentage:', error)
            if (percent === 1) {
              handleMax()
            }
          }
        }
      }
    },
    [amount, setInputValue, handleMax]
  )

  return {
    handleMax,
    handle10Percent: createPercentHandler(0.1),
    handle25Percent: createPercentHandler(0.25),
    handle50Percent: createPercentHandler(0.5),
    handle100Percent: handleMax,
  }
}
